import { useEffect } from 'react';

/**
 * モーダル等が開いている時に、背景のスクロールをロックするフック
 * @param isLocked ロックするかどうか（trueでロック）
 */

export const useBodyScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (!isLocked) return;

    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = prev;
    };
  }, [isLocked]);
};
